var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKmjleft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 46,
    viewBox: "0 0 31 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02005 26.2771L0 35.0609C0 45.0357 19.5023 45.0357 22.0337 45.0357C24.5651 45.0357 30.9658 46.0001 30.9658 46.0001C29.1794 29.1026 15.0363 21.5109 15.0363 21.5109L4.02005 26.2771Z",
    fill: "url(#paint0_linear_0_13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0753174 11.2417V35.9529C1.31353 33.5963 3.26821 31.6929 5.65753 30.5189C12.2873 27.2438 29.18 19.2049 30.9712 0C30.9712 0 24.198 1.19095 20.6239 1.78642C17.1921 2.30837 0.150053 2.45784 0.0753174 11.2417Z",
    fill: "url(#paint1_linear_0_13)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_13",
    x1: 24.7108,
    y1: 33.0696,
    x2: 11.5193,
    y2: 71.1208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FED600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#956B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30130D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_13",
    x1: 41.7848,
    y1: 70.1432,
    x2: -5.08713,
    y2: 70.7543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B16B28"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmjleft);
export default __webpack_public_path__ + "static/media/kmjleft.3342ede4bb21090fccb62cb2ec4bcee9.svg";
export { ForwardRef as ReactComponent };